import { RemoveRedEye } from '@mui/icons-material'
import { IconButton } from '@material-ui/core'

export const ButtonAction = ({ setFile, source, record }) => {
  return (
    <IconButton
      onClick={(e) => {
        e.preventDefault()
        if (record?.[source]) {
          setFile(record?.[source])
        }
      }}
      disabled={!record?.[source]}
    >
      <RemoveRedEye
        style={{ color: record?.[source] ? '#1976d2' : '#ced4da' }}
      />
    </IconButton>
  )
}

export default ButtonAction
